import navTemplate from './nav/template.html';
import navCtrl from './nav';
import editTemplate from './edit/template.html';
import editCtrl from './edit';
import attachmentsTemplate from './attachments/template.html';
import attachmentsCtrl from './attachments';
import extensionsTemplate from './extensions/template.html';
import extensionsCtrl from './extensions';
import templateCarryOver from './carryOver/template.html';
import controllerCarryOver from './carryOver';

const userLicensesLicenseNavState = {
  url: '/:reg_id',
  stateName: 'License',
  abstract: true,
  data: {
    specialClass: 'fixed-sidebar'
  },
  resolve: {
    ResolveClass: 'ResolveClass',
    authenticateCompany: /* @ngInject */ ResolveClass => ResolveClass.authenticateCompany('/licenses'),
    loadRegulators: /* @ngInject */ RegulatorClass => RegulatorClass.loadRegulators()
  },
  views: {
    'nav-a@app.users.settings': {
      template: navTemplate,
      controller: navCtrl,
      controllerAs: 'NavCtrl'
    }
  }
};

const userLicensesLicenseAttachmentsState = {
  url: '/attachments',
  stateName: 'License Attachments',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app.users.settings': {
      template: attachmentsTemplate,
      controller: attachmentsCtrl,
      controllerAs: 'LicenseAttachmentsCtrl'
    }
  }
};

const userLicensesLicenseCarryOverState = {
  url: '/carry-over',
  stateName: 'Carry-Over Hours',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app.users.settings': {
      template: templateCarryOver,
      controller: controllerCarryOver,
      controllerAs: 'LicenseCarryOverCtrl'
    }
  }
};

const userLicensesLicenseEditState = {
  url: '/edit',
  stateName: 'License Edit',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app.users.settings': {
      template: editTemplate,
      controller: editCtrl,
      controllerAs: 'LicenseEditCtrl'
    }
  }
};

const userLicensesLicenseExtensionsState = {
  url: '/extensions',
  stateName: 'License Extensions',
  data: {
    specialClass: 'fixed-sidebar'
  },
  views: {
    'a@app.users.settings': {
      template: extensionsTemplate,
      controller: extensionsCtrl,
      controllerAs: 'LicenseExtensionsCtrl'
    }
  }
};

export {
  userLicensesLicenseNavState,
  userLicensesLicenseAttachmentsState,
  userLicensesLicenseCarryOverState,
  userLicensesLicenseEditState,
  userLicensesLicenseExtensionsState
};



// WEBPACK FOOTER //
// ./src/app/controllers/users/account/licenses/license/index.js